export enum BuyTabsEnum {
  assets = 1,
  RequestHistory = 2,
}
